import './App.scss';
import React from 'react';
import PageLink from './components/layout/PageLink';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import SamplePage from './components/samplePage/';
import Home from './components/home/';
import DigitalDownload from './components/digitaldownload/';
import { Route } from 'react-router-dom';
import {mobilecheck} from './utils/utils.js'
import MobileRestricted from './components/samplePage/mobile-restricted.js'

function App(props) {
  // console.log(props);
  if(!mobilecheck()){
    return (
      <div>
        <PageLink />
        <Header />
        <div className="content-inner">
          <Route exact path="/" component={Home} />
          <Route exact path="/samples/:category?" component={SamplePage} />   
          <Route exact path="/digitaldownload" component={DigitalDownload} />        
        </div>
        <Footer />
      </div>
    );
  } else {
  return(
    <div>
      <MobileRestricted />
    </div>
    )
  }  
}

export default App;
